import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "orientation-switcher",
  id: "orientationSwitcher"
}

import { Orientation } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrientationSwitcher',
  props: {
    orientation: null
  },
  emits: ["orientationSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'orientationSelected', orientation: Orientation): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  orientation: Orientation
};






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["orientation-switcher__button orientation-switcher__button--portrait", {'orientation-switcher__button--active': __props.orientation === 'portrait' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('orientationSelected', 'portrait')))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["orientation-switcher__button orientation-switcher__button--landscape", {'orientation-switcher__button--active': __props.orientation === 'landscape' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('orientationSelected', 'landscape')))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["orientation-switcher__button orientation-switcher__button--square", {'orientation-switcher__button--active': __props.orientation === 'square' }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('orientationSelected', 'square')))
    }, null, 2)
  ]))
}
}

})